export enum ImmunizationTypeEnum {
  Pneumonia = 1,
  Flu = 2,
  Shingles = 3,
  Tetanus = 4,
  COVID19First = 5,
  COVID19Second = 6,
  COVID19Single = 7,
  COVID19Booster = 8,
  Other = 99
}

export const ImmunizationTypeOptions = [
{ id: 1, label: 'Pneumonia', displayForQuickAccess: false },
{ id: 2, label: 'Flu', displayForQuickAccess: true },
{ id: 3, label: 'Shingles', displayForQuickAccess: true },
{ id: 4, label: 'Tetanus', displayForQuickAccess: false },
{ id: 5, label: 'COVID 19 - First Shot', displayForQuickAccess: false },
{ id: 6, label: 'COVID 19 - Second Shot', displayForQuickAccess: false },
{ id: 7, label: 'COVID 19 - Single', displayForQuickAccess: false },
{ id: 8, label: 'COVID 19 - Booster', displayForQuickAccess: true },
{ id: 99, label: 'Other', displayForQuickAccess: false }
];
